<ifc-status-label [status]="labels" [value]="flag"></ifc-status-label>